export default __webpack_public_path__ + "static/media/Letter U.b0971782.mov";